import Image from 'next/image';
import { Button } from '../ui/button';
import { useRouter } from 'next/navigation';
export default function ErrorScreen({
  customText
}: {
  customText?: string;
}) {
  const router = useRouter();
  return <div data-sentry-component="ErrorScreen" data-sentry-source-file="ErrorScreen.tsx">
      <div className='h-[100vh] py-6 bg-genius-cream-foreground z-80 relative overflow-auto rounded-b-3xl purple-gradient-error'>
        <div className='ta-c h-[600px] flex items-center w-[100%]'>
          <div className='w-full'>
            <Image height={100} width={100} src={'/static/images/error.png'} alt={'error'} className={`w-[83px] h-[83px] mt-10 transition-opacity duration-500`} data-sentry-element="Image" data-sentry-source-file="ErrorScreen.tsx" />

            <div className='mw-[288px] px-4'>
              <p className={`mt-[100px] text-genius-gradient text-[24px] font-semibold leading-8`}>
                We’re sorry. Genius is not
                <br />
                working at the moment.
              </p>

              <p className='text-[10px] text-genius-cream/50 mt-10 w-[240px]'>
                Not very smart, we know. But we’re working on fixing it and should be back online
                soon. Please check your network connection. You can:{' '}
              </p>
            </div>

            <div className='w-full absolute bottom-6'>
              <Button onClick={() => window.open('https://datil-status.litprotocol.com/')} className='bg-genius-blue h-[56px] md:hover:bg-genius-blue text-genius-cream rounded-full w-[95%] text-[14px] mb-1' data-sentry-element="Button" data-sentry-source-file="ErrorScreen.tsx">
                Check Lit Protocol's Status
              </Button>
              <Button onClick={() => router.refresh()} className='bg-genius-blue h-[56px] md:hover:bg-genius-blue text-genius-cream rounded-full w-[95%] text-[14px] mb/1' data-sentry-element="Button" data-sentry-source-file="ErrorScreen.tsx">
                Refresh
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}